// Enum of account user roles
enum AccountRoles {
  DEMO = "DEMO",
  GUEST = "GUEST",
  MEMBER = "MEMBER",
  ANALYST = "ANALYST",
  ADMIN = "ADMIN",
  OWNER = "OWNER",
  ACCOUNT_OWNER = "ACCOUNT_OWNER",
}

export default AccountRoles;